function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString() + ';domain=vaultx.com';
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

function manualCountryRedirect() {
    expiry = new Date();
    expiry.setDate(expiry.getDate()+1);
    setCookie('vx-region-selector-manual', 1, expiry);
}


document.addEventListener("DOMContentLoaded", function() {

    let cookie_name = 'vx-region-selector-manual';

    let urlParams = new URLSearchParams(window.location.search);
    let manualRedirect = urlParams.get('mcr');
    if(manualRedirect == 1) {
        manualCountryRedirect();
    }

    if (getCookie(cookie_name) != '1') {
        if(
            window.location.hostname != 'vaultx.com' &&
            window.location.hostname != 'us.vaultx.com' &&
            window.location.hostname != 'eu.vaultx.com') {
           return;
        }
        let eu_countries = ['BE','BG','CZ','DK','DE','EE','IE','EL','ES','FR','HR','IT','CY','LV','LT','LU','HU','MT','NL','AT','PL','PT','RO','SI','SK','FI','SE'];

        // Get customer data including country
        let url = '/browsing_context_suggestions.json'
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'json';
        xhr.onload = function() {
            let doUserRedirect = true;
            let status = xhr.status;
            if (status === 200) {
                 // Don't show the popup if customer country corresponds to the domain
                 if ( (xhr.response.detected_values.country.handle != 'US' && !eu_countries.includes(xhr.response.detected_values.country.handle) && window.location.hostname == 'www.vaultx.com')
                    ||
                    (xhr.response.detected_values.country.handle == 'US' && window.location.hostname == 'us.vaultx.com') 
                    ||
                    (eu_countries.includes(xhr.response.detected_values.country.handle) && window.location.hostname == 'eu.vaultx.com')
                    ||
                    (xhr.response.detected_values.country.handle == 'CA' && window.location.hostname == 'ca.vaultx.com') ) {
                        doUserRedirect = false;
                    }
            }

            if (doUserRedirect) {
                let redirectTo = 'https://vaultx.com';
                if(xhr.response.detected_values.country.handle == 'US') {
                    redirectTo = 'https://us.vaultx.com';
                }
                if(eu_countries.includes(xhr.response.detected_values.country.handle)) {
                    redirectTo = 'https://eu.vaultx.com';
                }
                if(xhr.response.detected_values.country.handle == 'CA') {
                    redirectTo = 'https://ca.vaultx.com';
                }
                redirectUser(redirectTo, 'auto_redirect');
            }
        };
        xhr.send();
    }
});

function showCountrySelectorPopup(e) {
    e.preventDefault();
    let redirectPopupOverlay = document.querySelector('.uk-us-redirect_overlay');
    let redirectPopupClose = document.querySelector('.uk-us-redirect_overlay .close');
    let redirectPopupButton = document.querySelector('.redirect-popup-button');
    redirectPopupOverlay.style.display = 'block';

    redirectPopupOverlay.addEventListener('click', function(e){
        if (e.target !== this)
            return;
        
        redirectPopupOverlay.style.display = 'none';
        document.body.classList.remove('redirect-popup-open');
    });
    redirectPopupClose.addEventListener('click', function(e){
        redirectPopupOverlay.style.display = 'none';
        document.body.classList.remove('redirect-popup-open');
    });
    redirectPopupButton.addEventListener('click', function(){
        let countrySelected = document.querySelector('input[name=selected-store]:checked');
        manualCountryRedirect();

        if(countrySelected == undefined) {
            redirectPopupOverlay.style.display = 'none';
        } else {
            let redirectTo = 'https://vaultx.com';
            if (countrySelected.value == 'eu') {
                redirectTo = 'https://eu.vaultx.com';
            } else if (countrySelected.value == 'ca') {
                redirectTo = 'https://ca.vaultx.com';
            } else if (countrySelected.value == 'us') {
                redirectTo = 'https://us.vaultx.com';
            }
            redirectUser(redirectTo, 'popup');
        }
    });
}

function redirectUser(redirect_to, content) {
    if(navigator.userAgent.toLowerCase().includes('bot')) {
        return;
    }
    let utm_source = 'vaultxuk';
    switch(window.location.hostname) {
        case 'eu.vaultx.com':
            utm_source = 'vaultxeu';
            break;
        case 'us.vaultx.com':
            utm_source = 'vaultxus';
            break;
        case 'ca.vaultx.com':
            utm_source = 'vaultxca';
            break;
    }
    let query_string_start = '?';
    if (window.location.search.indexOf("?") != -1) {
        query_string_start = '&';
    }
    window.location.href = redirect_to + window.location.pathname + window.location.search + query_string_start + 'utm_source=' + utm_source + '&utm_medium=website&utm_content='+content;
}